import { pickFirstNonEmptyString } from "../../Analysis/shared/analysisListUtils";

export const onlyDigits = (v: string | null | undefined) =>
  String(v || "").replace(/\D/g, "");

function normKeySituacao(s: string): string {
  return String(s || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function normalizeSituacaoExtratoNome(
  situacao: string | null | undefined,
): string {
  if (situacao == null || String(situacao).trim() === "") return "-";
  const k = normKeySituacao(situacao);

  if (k === "analise nao finalizada") return "Análise não finalizada";
  if (k === "extrato pendente") return "Extrato Pendente";
  if (k === "extrato enviado") return "Extrato Enviado";
  if (k === "extrato validado") return "Extrato Validado";
  if (k === "inapto") return "Inapto";

  return String(situacao).trim();
}

export function pickExtratoStatusNomeApi(item: unknown): string | null {
  const row = item as Record<string, unknown>;

  const status = row?.status ?? row?.Status;
  if (status && typeof status === "object") {
    const nome = pickFirstNonEmptyString(
      (status as { nome?: string }).nome,
      (status as { Nome?: string }).Nome,
    );
    if (nome) return nome;
  }

  const situacao = row?.situacao ?? row?.Situacao;
  if (situacao && typeof situacao === "object") {
    const nome = pickFirstNonEmptyString(
      (situacao as { nome?: string }).nome,
      (situacao as { Nome?: string }).Nome,
    );
    if (nome) return nome;
  }

  const st = row?.statusExtrato ?? row?.StatusExtrato;
  if (st && typeof st === "object") {
    const nome = pickFirstNonEmptyString(
      (st as { nome?: string }).nome,
      (st as { Nome?: string }).Nome,
    );
    if (nome) return nome;
  }

  return pickFirstNonEmptyString(
    row?.situacaoExtrato,
    row?.SituacaoExtrato,
    row?.situacaoExtato,
    row?.SituacaoExtato,
  );
}

export function pickSituacaoIdApi(item: unknown): number | null {
  const row = item as Record<string, unknown>;

  const status = row?.status ?? row?.Status;
  if (status && typeof status === "object") {
    const id = (status as { id?: number }).id;
    if (typeof id === "number") return id;
  }

  const situacao = row?.situacao ?? row?.Situacao;
  if (situacao && typeof situacao === "object") {
    const id = (situacao as { id?: number }).id;
    if (typeof id === "number") return id;
  }

  const st = row?.statusExtrato ?? row?.StatusExtrato;
  if (st && typeof st === "object") {
    const id = (st as { id?: number }).id;
    if (typeof id === "number") return id;
  }

  return null;
}

export function resolveSituacaoExtratoParaLista(
  item: unknown,
  sind?: unknown,
): string {
  const sindRow = sind as Record<string, unknown> | undefined;
  const sindSituacaoGeral = pickFirstNonEmptyString(sindRow?.situacao);
  if (normKeySituacao(sindSituacaoGeral || "") === "inapto") {
    return "Inapto";
  }

  const nomeApi = pickExtratoStatusNomeApi(item);
  if (nomeApi) {
    return normalizeSituacaoExtratoNome(nomeApi);
  }

  const fallbackSind = pickFirstNonEmptyString(
    sindRow?.situacaoExtato,
    sindRow?.situacaoExtrato,
  );
  if (fallbackSind) {
    return normalizeSituacaoExtratoNome(fallbackSind);
  }

  return "Análise não finalizada";
}

export function normalizeExtratoListItemDates(item: unknown) {
  const row = item as Record<string, unknown>;
  return {
    envio: pickFirstNonEmptyString(
      row?.dataEnvioExtrato,
      row?.DataEnvioExtrato,
      row?.enviadoEm,
      row?.EnviadoEm,
    ),
    atualizacao: pickFirstNonEmptyString(
      row?.dataAtualizacaoExtrato,
      row?.DataAtualizacaoExtrato,
      row?.dataAtuaizacaoExtrato,
      row?.atualizadoEm,
      row?.AtualizadoEm,
    ),
  };
}

export function rowSituacaoExtratoMatchesFilters(
  situacaoRow: string | undefined,
  selectedSituation: string[],
  allSituations: string[],
): boolean {
  if (selectedSituation.length === 0) return false;
  if (
    selectedSituation.length === allSituations.length &&
    allSituations.every((s) => selectedSituation.includes(s))
  ) {
    return true;
  }

  const rowNorm = normKeySituacao(situacaoRow || "");
  return selectedSituation.some(
    (s) => normKeySituacao(s) === rowNorm,
  );
}
